import { InputMask } from "primereact/inputmask";
import type { ComponentProps } from "react";

import { Label } from "components/v2";

import { ACCRUAL_DATE_MASK } from "../helpers/accrualDateFormat";

type AccrualDateInputPropsT = {
  id: string;
  label?: string;
  name?: string;
  value: string;
  onChange?: (e: { target: { name?: string; value: string } }) => void;
  error?: string;
  helperText?: string;
  isRequired?: boolean;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
};

const AccrualDateInput = ({
  id,
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  isRequired,
  disabled,
  className,
  inputClassName,
}: AccrualDateInputPropsT) => {
  const labelId = `${id}-label`;
  const helperId = `${id}-helper`;
  const describedBy = !error && helperText ? helperId : undefined;

  const handleChange: NonNullable<
    ComponentProps<typeof InputMask>["onChange"]
  > = (e) => {
    onChange?.({ target: { name, value: e.value ?? "" } });
  };

  return (
    <section
      aria-labelledby={label ? labelId : undefined}
      className="flex flex-col gap-1 w-full"
    >
      {!!label && (
        <div id={labelId}>
          <Label htmlFor={id} text={label} isRequired={!!isRequired} />
        </div>
      )}
      <div className={`p-inputgroup ${className || ""}`.trim()}>
        <InputMask
          id={id}
          mask={ACCRUAL_DATE_MASK}
          placeholder="dd/mm/aaaa"
          aria-labelledby={label ? labelId : undefined}
          aria-required={isRequired || undefined}
          aria-invalid={!!error}
          aria-describedby={describedBy}
          name={name}
          value={value}
          disabled={disabled}
          onChange={handleChange}
          className={`!h-5 ${error ? "p-invalid " : ""}${inputClassName ?? ""}`.trim()}
        />
      </div>
      {!!helperText && !error && (
        <small id={helperId} className="-mt-1 text-gray-500">
          {helperText}
        </small>
      )}
    </section>
  );
};

export default AccrualDateInput;
